import React, { Component } from "react";
import * as config from "../config";

export default class ErrorBoundary extends Component {
    constructor(props) {
        super(props);       

        this.state = { error: null };
    }

    componentDidCatch(error, errorInfo) {
    	this.setState({ error });    	
    }

    render() {    	
        if (this.state.error && config.handleErrors) {
            return (
                <div className="warning-box p-3 mt-4 text-bold text-center">                    
        			 <p>An error has occurred on the site, and AANP has been alerted of the issue.&nbsp;&nbsp;Please return to the <a href={config.rootUrl}>home page</a> or try again later.</p>
        		</div>
            );
        } else {
            return this.props.children;
        }
    }
}